import { useState } from "react";
import Button from "@/shared/ui/button/Button";

export function DevTriggerError() {
  const [data, setData] = useState({ name: "John" });

  return (
    <div className="relative z-100">
      <pre className="hidden">{data.name}</pre>

      {/* eslint-disable-next-line react/button-has-type */}
      <Button variant="surface" onClick={() => setData(null)}>
        Trigger Error
      </Button>
    </div>
  );
}
